var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.show
    ? _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _setup.tableName
            ? _c(_setup.ComponentSettingsBtn, {
                staticClass: "me-1",
                class: { active: _setup.routeName === "componentSettings" },
                attrs: { "table-name": _setup.tableName },
              })
            : _vm._e(),
          _vm._v(" "),
          _setup.tableName
            ? _c(_setup.ComponentFieldsBtn, {
                class: { active: _setup.routeName === "componentFields" },
                attrs: { "table-name": _setup.tableName },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }